import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import * as Bowser from "bowser";
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BadBrowserGuard  {
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.isSupportedBrowser;
  }

  get isSupportedBrowser(): boolean {

    const browser = Bowser.getParser(window.navigator.userAgent);

    console.log("browser: ", Bowser.parse(window.navigator.userAgent));

    return browser.satisfies({
      chrome: ">=87",
      edge: ">=86",
      safari: ">=13",
      firefox: ">=88"
    });
  }

}
